(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('FranchiseeHistoryService', FranchiseeHistoryService)

    /** @ngInject */
    function FranchiseeHistoryService(HttpService) {
        const FranchiseeHistoryService = {
            getByParameters: getByParameters,
            get: get,
            post: post,
            put: put
        }

        return FranchiseeHistoryService;

        function getByParameters(params) {
            return HttpService.get('/franchisees', {
                params
            });
        }

        function get(franchiseeId) {
            return HttpService.get(`/franchisees/${franchiseeId}`);
        }

        function post(franchiseeData) {
            return HttpService.post('/franchisees', franchiseeData);
        }

        function put(franchiseeData) {
            return HttpService.put('/franchisees', franchiseeData);
        }
    }
}());